import api from "../../../../services/api";
import { IconClose } from "../../../icons";
import ModalDefault from "../../../ModalDefault";
import { ModalContactHead } from "../../../SearchProfessionalProposal/styles";
import ResolvePendenciaDocumentos from "./ResolvePendenciaDocumentos";
import { Container, ModalContent } from "./styles";
import { useHistory } from "react-router-dom";
import { useState, useRef } from "react";
import ResolvePendenciaComum from "./ResolvePendenciaComum";
import ResolvePendenciaPagamento from "./ResolvePendenciaPagamento";
import toastservice from "../../../../services/toast";

export default function ModalResolverPendencia({
    modalAtivo,
    setModalAtivo,
    pendencia,
    profissional,
    arquivos,
    enviarArquivos,
}: {
    modalAtivo: boolean;
    setModalAtivo: (modalAtivo: boolean) => void;
    pendencia: any;
    profissional: any;
    arquivos: any;
    enviarArquivos: (arquivos: any) => void;
}) {
    const history = useHistory();
    const [resposta, setResposta] = useState('');
    const documentosRef = useRef<any>(null);

    const tipos: any = {
        documentacao: 'docs',
        informacao: 'comum',
        orientacao: 'comum',
        correcao: 'comum',
        marjoracao: 'pagamento',
        reembolso: 'pagamento',
        adiantamento: 'pagamento',
        s_informacao: 'comum',
    }

    function validaRetornoRespondePendencia(response: any) {

            if (response.data.status !== 'success') {
                if (response.data.result[0] === undefined || typeof response.data.result === 'string') {
                    throw new Error(response.data.message);

                } else {
                    throw new Error(response.data.result[0].message || response.data.result[0].error);
                }
            } else {
                toastservice.success('Pendência respondida com sucesso');
                setModalAtivo(false);
                window.location.reload();
            }
    }

    async function respondePendencia(aceitar: string) {
        try {
            // Para pendências de documentação, usa os arquivos da ref
            const arquivosParaEnviar = tipos[pendencia.tipo] === 'docs' && documentosRef.current 
                ? documentosRef.current.getArquivos() 
                : arquivos;

            const pendency = {
                aceitar, arquivos: arquivosParaEnviar, resposta
            }

            const response = await api.put('pendencia-responder/' + pendencia.id_pendencia, pendency);

            validaRetornoRespondePendencia(response);
            
        } catch (error: any) {
            toastservice.error(error.message);
        }
    }

    return (
        <Container>
            {
            pendencia && pendencia.id_pendencia !== undefined &&
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setModalAtivo(false)}
                openModal={modalAtivo}
                width="100%"
                maxWidth="512px"
            >
                <ModalContactHead>
                    <div>
                        Responder pendência
                    </div>

                    <div
                        className="close-pendencie"
                        onClick={() => setModalAtivo(false)}
                    >
                        <IconClose />
                    </div>
                </ModalContactHead>

                <ModalContent>                  
                    {
                        tipos[pendencia.tipo] === 'docs' &&
                        <ResolvePendenciaDocumentos
                            ref={documentosRef}
                            profissional={profissional}
                            pendencia={pendencia}
                            arquivos={pendencia.arquivos}
                            enviarArquivos={enviarArquivos}
                            resolvePendencia={() => respondePendencia('sim')}
                            fechaPendencia={() => setModalAtivo(false)}
                            setResposta={setResposta}
                        />
                    }

                    {
                        tipos[pendencia.tipo] === 'comum' &&
                        <ResolvePendenciaComum
                            profissional={profissional}
                            pendencia={pendencia}
                            resolvePendencia={() => respondePendencia('sim')}
                            fechaPendencia={() => setModalAtivo(false)}
                            setResposta={setResposta}
                        />
                    }

                    {
                        tipos[pendencia.tipo] === 'pagamento' &&
                        <ResolvePendenciaPagamento
                            profissional={profissional}
                            pendencia={pendencia}
                            recusaPendencia={() => respondePendencia('nao')}
                            resolvePendencia={() => respondePendencia('sim')}
                        />
                    }
                </ModalContent>

            </ModalDefault>

            }
        </Container>
    )
}